import { gql } from "@apollo/client";

const GET_PRODUCT_LISTING = gql`
  query {
    getProductListingSetting {
      data {
        isEnabled
        updatedAt
      }
      error
      status
    }
  }
`;

export default GET_PRODUCT_LISTING;
